import { BlankReceipt } from './blank-receipts.interface';

export const BLANK_RECEIPTS_INITIAL_STATE: BlankReceipt = {
  saving: false,
  request: null,
  shipTos: [],
};
